(function () {
  'use strict';

  angular
    .module('app.page-project-building-types', []);
})();
